import { Card, Badge } from '@dreamtree-org/twreact-ui';
import { Package, ShieldCheck, BatteryMedium } from 'lucide-react';
import { Money } from '@/components';
import { discountPct } from '../lib/money';
import { modelSpecs, labelOf } from '../lib/catalog';

/**
 * How a listing will look on the public storefront (SELL-04 "public preview").
 * Shows only public fields: never acquisition cost or the serial hash.
 */
export default function ListingPreviewCard({ title, pricePaise, mrpPaise, warrantyMonths, unit, model, photoUrl, storeName }) {
  const off = discountPct(pricePaise, mrpPaise);
  return (
    <Card className="overflow-hidden max-w-sm w-full">
      <div className="aspect-[4/3] bg-[var(--app-bg)] flex items-center justify-center border-b border-[var(--app-border)]">
        {photoUrl ? <img src={photoUrl} alt="" className="h-full w-full object-cover" /> : <Package size={64} className="opacity-30" aria-hidden />}
      </div>
      <div className="p-4 space-y-2">
        <div className="flex flex-wrap gap-1">
          {unit && unit.condition ? <Badge variant="secondary" size="sm">{labelOf(unit.condition)}</Badge> : null}
          {unit && unit.grade ? <Badge variant="primary" size="sm">Grade {unit.grade}</Badge> : null}
          {off ? <Badge variant="success" size="sm">{off}% off</Badge> : null}
        </div>
        <h3 className="font-semibold leading-snug">{title || 'Listing title'}</h3>
        {model ? <p className="text-sm opacity-70">{modelSpecs(model)}</p> : null}
        <div className="text-xl font-bold">
          {pricePaise ? <Money paise={pricePaise} mrp={mrpPaise && mrpPaise > pricePaise ? mrpPaise : null} /> : <span className="opacity-50">Price not set</span>}
        </div>
        <ul className="text-sm space-y-1 opacity-80">
          <li className="flex items-center gap-2"><ShieldCheck size={16} aria-hidden /> {warrantyMonths ? `${warrantyMonths}-month seller warranty` : 'No seller warranty'}</li>
          {unit && unit.battery_health_pct != null ? <li className="flex items-center gap-2"><BatteryMedium size={16} aria-hidden /> Battery health {unit.battery_health_pct}%</li> : null}
        </ul>
        {storeName ? <p className="text-xs opacity-60">Sold by {storeName} · Verified seller</p> : null}
      </div>
    </Card>
  );
}
